import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["dsf_href"]

import { useSennderLanguageUrl } from './sennderUrlHelper'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImprintLink',
  setup(__props) {

const imprintUrl = useSennderLanguageUrl('imprint')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("dsf-link", {
    dsf_size: "medium",
    dsf_href: _unref(imprintUrl)
  }, _toDisplayString(_ctx.$t('imprintLabel')), 9 /* TEXT, PROPS */, _hoisted_1))
}
}

})